export enum FeeType {
  BankingPartner = 'BANKING_PARTNER',
  CrossBorderFee = 'CROSS_BORDER_FEE',
  PaymentProvider = 'PAYMENT_PROVIDER',
  PaymentProviderBatch = 'PAYMENT_PROVIDER_BATCH',
  Verifone = 'VERIFONE',
  VerifoneProcessingFee = 'VERIFONE_PROCESSING_FEE',
}
